import { handleRoute } from "../https";

export const configureNursery = async ({
  companyId,
  id: benefitModelId,
  ...rest
}) => {
  const res = await handleRoute({
    method: "put",
    path: `/v1/companies/${companyId}/benefits/${benefitModelId}`,
    payload: { id: benefitModelId, companyId, ...rest },
  });
  return res;
};
